export const buildSourceNameVariables = ({
  name,
  startDate,
  expirationDate,
  cidrBlocks
}: {
  name: string
  startDate?: Date
  expirationDate?: Date
  cidrBlocks: string[]
}) => {
  return {
    sourceName: {
      name,
      start: startDate && startDate.toISOString(),
      expiration: expirationDate && expirationDate.toISOString(),
      cidrBlocks: cidrBlocks
        .filter((cidrBlock) => cidrBlock.length > 0)
        .map((cidrBlock) => cidrBlock.trim())
    }
  }
}
